import { render, staticRenderFns } from "./DescriptionForm.vue?vue&type=template&id=13fb113d&scoped=true&"
import script from "./DescriptionForm.vue?vue&type=script&lang=js&"
export * from "./DescriptionForm.vue?vue&type=script&lang=js&"
import style0 from "./DescriptionForm.vue?vue&type=style&index=0&id=13fb113d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13fb113d",
  null
  
)

export default component.exports